<template>
    <div :class="[
        { 'sale-page-one': $route.path == '/sale-page-one' },
        { 'sale-page-two': $route.path == '/sale-page-two' },
    ]">
        <v-app-bar  height="72" app scroll-off-screen  class="sub-topbar brd-header-color" >
            <v-container>
                <div class="d-flex justify-space-between align-center">
                    <v-toolbar-title class="d-flex align-center">
                        <div>
                            <!-- <HeaderNavbar />-->
                            <v-btn icon tile @click="toggleDrawer();">
                                <v-icon color="white">mdi-menu</v-icon>
                            </v-btn>
                        </div>
                        <router-link to="/">
                            <img class="me-2 logo" width="130" :src="agent_logo"
                                alt="">
                        </router-link>
                      
                       
                    </v-toolbar-title>
                   
                    <div class="">
                        <div class="">
                            <v-dialog absolute hide-overlay v-model="getModalLogin" width="500" @click:outside="SetModalClose()">



                                <!-- <base-card class="custom-dialog"> -->
                                <base-card class="bg-gold" >
                                    <div class="px-3 px-md-10 py-8 ">
                                        <h3 class="mb-2 text-center">Log In</h3>
                                       
                                        <p class="text-14 mb-1">Phone Number</p>
                                        <v-text-field v-model="Username" outlined dense hide-details placeholder=""
                                            class="mb-4"></v-text-field>
                                        <p class="text-14 mb-1">Password</p>
                                        <v-text-field v-model="Password"  outlined dense type="password" hide-details
                                            placeholder="" class="mb-4"></v-text-field>
                                        <v-btn block color="primary" class="text-capitalize font-600" @click="SignIn()">Login</v-btn>
                                        <v-col cols="10" lg="8" class="mx-auto">
                                            <div class="d-flex align-center my-1">
                                                <v-divider></v-divider>
                                                <span class="mx-4">OR</span>
                                                <v-divider></v-divider>
                                            </div>
                                        </v-col>
                                        <v-btn block dark color="green" class="text-capitalize font-600 mb-4"  @click="SignInWithLine()">

                                            <v-icon left class="me-3">mdi-line</v-icon>
                                            Login Line

                                        </v-btn>
                                        <div class="text-14 text-center my-3">Don't have account? <a
                                                 class=" grey--text text--darken-4 font-600" @click="setModalGoToRegister()">Register
                                        </a></div>
                                    </div>
                                </base-card>
                            </v-dialog>
                            <v-dialog v-model="getModalRegister" width="500" @click:outside="SetModalRegisClose()">
                                <base-card class="bg-gold">
                                    <div class="px-3 px-md-10 py-8 ">
                                        <h3 class="mb-2 text-center">Register</h3>
                                        <div v-if="getRegisterStep == null">
                                            <p class="text-14 mb-1">Phone Number</p>
                                            <v-text-field v-model="register_tel" outlined dense hide-details placeholder="Phone Number"
                                                class="mb-4"></v-text-field>
                                            <v-btn block dark color="green" class="text-capitalize font-600 mb-4"  @click="SendRequestOTP()">
    
                                                <v-icon left class="me-3">mdi-page-next</v-icon>
                                                Next
    
                                            </v-btn>
                                        </div>
                                        <div v-if="getRegisterStep == 'step_confirm_otp'">
                                            <p class="text-14 mb-1">กรุณายืนยันตัวตนด้วยรหัส OTP 6 หลัก</p>
                                            <v-text-field v-model="register_opt_verify" outlined dense hide-details placeholder="OTP"
                                                class="mb-4"></v-text-field>
                                            <v-btn block dark color="green" class="text-capitalize font-600 mb-4"  @click="SendRequestOTPVerify()">
    
                                                <v-icon left class="me-3">mdi-page-next</v-icon>
                                                Next
    
                                            </v-btn>
                                        </div>
                                        <div v-if="getRegisterStep == 'step_password'">
                                            <p class="text-14 mb-1">กรุณากรอกป้อนรหัสผ่านเพื่อเข้าสู่ระบบ</p>
                                            <v-text-field v-model="register_pass" outlined dense hide-details placeholder="Password"
                                                class="mb-4"></v-text-field>
                                            <v-text-field v-model="register_pass_confirm" outlined dense hide-details placeholder="Confirm Password"
                                                class="mb-4"></v-text-field>
                                            <v-btn block dark color="green" class="text-capitalize font-600 mb-4"  @click="SendPassword()">
    
                                                <v-icon left class="me-3">mdi-page-next</v-icon>
                                                Next
    
                                            </v-btn>
                                        </div>
                                        <div v-if="getRegisterStep == 'step_bank_account'">
                                            <p class="text-14 mb-1">ประเภทบัญชี</p>
                                            <v-radio-group v-model="radios" row>
                                                <v-radio value="type_bank_account" color="green">
                                                    <template v-slot:label>
                                                        <div><strong class="success--text">บัญชีธนาคาร</strong></div>
                                                    </template>
                                                </v-radio>
                                                <v-radio value="type_true_money" color="red">
                                                    <template v-slot:label>
                                                        <div><strong class="primary--text">บัญชีทรูมันนี่</strong></div>
                                                    </template>
                                                </v-radio>
                                                <!-- {{ getBankList }} -->
                                            </v-radio-group>
                                            <div v-if="radios == 'type_bank_account'">
                                                    <div>
                                                        <v-select
                                                            class="mb-4"
                                                            v-model="bankAccount"
                                                            :items="getBankList"
                                                            placeholder="เลือกธนาคาร"
                                                            item-value="code"
                                                            persistent-hint
                                                            return-object
                                                            single-line
                                                            outlined dense hide-details
                                                            >
                                                            <template v-slot:selection="{ item }">
                                                                <div>
                                                                    <strong class="primary--text">{{ item.code }}</strong>
                                                                    <span class="ms-2">{{ item.desc.th }}</span>
                                                                </div>
                                                            </template>
                                                            <template v-slot:item="{ item }">
                                                                <div>
                                                                    <strong class="primary--text">{{ item.code }}</strong>
                                                                    <span class="ms-2">{{ item.desc.th }}</span>
                                                                </div>
                                                            </template>
                                                        </v-select>
                                                    </div>
                                                    <div>
                                                        <v-text-field :disabled="bankAccount == '' || bankAccount == null" v-model="bankAccountNo" outlined dense hide-details placeholder="เลขที่บัญชี"
                                                            class="mb-4"></v-text-field>
                                                    </div>
                                                    <div>
                                                        <v-text-field v-if="isAllowBankName"  v-model="bankAccountName" outlined dense hide-details placeholder="ชื่อบัญชี"
                                                            class="mb-4"></v-text-field>
                                                    </div>
                                                </div>
                                            <v-btn  block dark color="green" class="text-capitalize font-600 mb-4 mt-4"  @click="SendRegister()">
                                                <v-icon left class="me-1">mdi-check-circle-outline</v-icon>
                                                สมัครสมาชิก
                                            </v-btn>
                                        </div>
                                    </div>
                                </base-card>
                            </v-dialog>
                            <div class="d-flex align-center" v-if="getIsLogin == false">
                                <v-btn  size="small" color="gold"  class="text-capitalize bg-gold me-2" @click="setModalLogin(true)">Login </v-btn>
                                <!-- <v-btn  size="small" color="gold "  class="text-capitalize bg-gold ms-2" @click="setModalRegister(true)">Register </v-btn> -->
                            </div>
                            <div class="d-flex align-center me-3" v-else>
                                <div>
                                    <div class="text-right">
                                        <span class="text-white">{{ getDataLogin.Username }}</span>
                                    </div>
                                    <div class="d-flex">
                                        <span class="text-white">Credit {{ getBalance }}</span>
                                        <div class=" reload-position-header cursor-pointer ms-2" @click="GetBalance(true)">
                                            <v-icon color="white">mdi-reload</v-icon>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </v-container>
        </v-app-bar>
        <v-navigation-drawer v-model="drawer" fixed temporary right width="320" class="z-999 bg-gold">
            <div class="secondary-siebar-content">
                <v-list-item>
                    <!-- <v-list-item-avatar class="mr-0">
                        <v-icon color="">mdi-shopping-outline</v-icon>
                    </v-list-item-avatar> -->

                    <v-list-item-content>
                        <v-list-item-title class="">Menu</v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action>
                        <v-btn icon color="" @click="drawer = false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-list-item-action>
                </v-list-item>
                <v-divider></v-divider>
                <div class="cursor-pointer" v-for="(itemMenu, indexMenu) in getMenuList" :key="indexMenu" :class="indexMenu > 0 ? 'mt-2' : ''">
                    <div class="d-flex draw-menu" @click="goToMenu(itemMenu)">
                        <div class="draw-menu-icon d-flex justify-start align-center">
                            <v-icon color="white">{{ itemMenu.icon }}</v-icon>
                        </div>
                        <div class="draw-menu-label ms-2  d-flex justify-start align-center">
                            {{ itemMenu.title }}
                        </div>
                    </div>
                </div>
                <!-- <div v-if="getCartProducts.length >= 1">
                    <div v-for="(n, index) in getCartProducts" :key="index">
                        <div class="cart-item d-flex justify-space-between align-center px-2 py-3">
                            <div class="d-flex flex-column align-center">
                                <v-btn @click="addCartx(n)" class="mx-2" fab outlined dark x-small color="primary">
                                    <v-icon dark> mdi-plus </v-icon>
                                </v-btn>
                                <span>{{ n.qty }}</span>
                                <v-btn @click="removeCartx(n)" class="mx-2" fab outlined dark x-small color="primary">
                                    <v-icon dark> mdi-minus </v-icon>
                                </v-btn>
                            </div>
                            <v-avatar tile size="76">
                                <img :src="n.img" alt="" />
                            </v-avatar>
                            <div class="col-5">
                                <h5 class="text-truncate">{{ n.title }}</h5>
                                <p class="text-tiny">${{ n.amount }} x {{ n.qty }}</p>
                                <h5 class="primary--text">{{ n.amount * n.qty }}</h5>
                            </div>

                        </div>
                        <v-divider></v-divider>
                    </div>
                </div>
                <div v-else>
                    <div class="empty-cart-sidebar d-flex flex-column justify-center align-center mt-10">
                        <v-avatar size="90" tile class="mb-8">
                            <img src="@/assets/images/empty-cart.png" alt="">
                        </v-avatar>
                        <p class="grey--text text--darken-2 px-5 mx-10 text-center ">Your shopping bag is empty. Start
                            shopping
                        </p>
                    </div>
                </div> -->

            </div>
            <template v-slot:append v-if="getCartProducts.length >= 1">
                <div class="pa-2">
                    <v-btn to="/checkout-alternative" class="text-capitalize mb-3" block color="primary">
                        Checkout Now (${{ cartTotal }})
                    </v-btn>
                    <v-btn to="/cart" class="text-cappitalise" outlined block color="primary">
                        View Cart
                    </v-btn>
                </div>
            </template>
        </v-navigation-drawer>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import HeaderNavbar from "@/views/home/header-navbar";
import Navbar from "@/views/home/navbar";
import { directive as onClickaway } from "vue-clickaway";
import { create } from 'lodash';
import { createToastInterface } from 'vue-toastification';
export default {
    name: "BaseAppBar",
    directives: {
        onClickaway: onClickaway,
    },
    components: {
        HeaderNavbar,
        Navbar,
    },

    computed: {
        ...mapGetters(['getMenuList' ,'getCartProducts', 'getIsLogin', 'getDataLogin', 'getModalLogin', 'getModalRegister', 'getRegisterStep', 'getBankList', 'getGameCategoryList', 'getIsLoadingProgress', 'getBannerHome', 'getBalance']),
        cartTotal() {
            let total = 0;
            this.getCartProducts.forEach(product => {
                total += product.amount * product.qty
            })
            return total;
        }
    },
    data: () => ({

        cartCount: 0,
        colorNav: false,
        dialog: false,
        isToggleNavbar: false,
        items: [
            { title: "Car" },
            { title: "Clothes" },
            { title: "Electronics" },
            { title: "Laptop" },
        ],
        itemTwo: ["Foo", "Bar", "Fizz", "Buzz"],
        drawer: false,
        group: null,
        Username: "",
        Password: "",
        register_tel: "",
        register_opt_verify: "",
        register_pass: "",
        register_pass_confirm: "",
        radios: 'type_bank_account',
        bankAccount: null,
        bankAccountNo: "",
        bankAccountName: "",
        isAllowBankName: false,
        agent_username: process.env.VUE_APP_AGENT,
        agent_logo: require(process.env.VUE_APP_LOGO),
    }),
    async created() {
        // await this.authenSycn();
        // check $route.path register
        this.setAfToken('')
        // console.log('AppBar.vue => created' , this.$route.path)
        if (this.$route.path == '/register') {
            this.setModalRegister(true);
            // console.log('AppBar.vue => created' , this.$route.query)
            if (this.$route.query.hasOwnProperty('aff')) {
                this.setAfToken(this.$route.query.aff)
            }
        }
        // get parameterby url
        await this.GetBalance();
        let res = await this.GetGamePage({is_loading: false});
        if (res != null && typeof res == 'object' && res.hasOwnProperty('Status') && res.Status == 'OK') {
            let limit = 3 ,
            newArr = []
            // console.log('AppBar.vue => created' , res.Data.GameCategory)
            if (res.Data.GameCategory.length > 0) {
                await this.GetGamePage({GAME_CATEGORY_ID: res.Data.GameCategory[0]['GAME_CATEGORY_ID'], GAME_HITS: true, is_loading: false}) 
                for (let index in res.Data.GameCategory) {
                    if (newArr.length != limit) {
                        newArr.push(res.Data.GameCategory[index]['GAME_CATEGORY_ID'])
                        await this.GetGamePage({GAME_CATEGORY_ID: res.Data.GameCategory[index]['GAME_CATEGORY_ID'], GAME_HITS: true, GAME_HOME: true, is_loading: false}) 
                    } else {
                        break
                    }
                }
            }
            // console.log('AppBar.vue => created' , newArr)
        }
        this.MemberTextAnnounce()
        // console.log('AppBar.vue => created' , res)
    },
    methods: {
        ...mapActions(['MemberTextAnnounce', 'setAfToken', 'logout',"addCart", "removeCart", "signIn", 'authenSycn', 'setModalLogin', 'signInWithLine', 'setModalRegister', 'requestOTP', 'ConfirmOTP', 'CheckPassword', 'RegisterData', 'GetGamePage', 'setIsLoadingProgress', 'GetBalance']),
        gotoGameList() {
            this.$router.push({ name: "Mobile Categories" });
        },
        convertImage(image) {
            let mdIconName = ""
            // fa-tachometer-alt-slowest
            // fal_fa-gamepad-alt
            // fal_fa-club
            // fal_fa-chess
            // fas_fa-bomb
            // far_fa-dice
            // fad fa-snake
            // far_fa-meteor
            // far_fa-rocket
            // far_fa-diamond
            // fas_fa-user-robot
            // fal_fa-raygun
            // fal_fa-dice-d10
            // fas_fa-dice-d6
            // console.log('Home.vue -> convertImage -> image', image)
            if (image == 'fas fa-spade') {
                mdIconName = "mdi-cards-spade"
            } else if (image == 'fas fa-club') {
                mdIconName = "mdi-cards-club"
            } else if (image == 'fas fa-dice') {
                mdIconName = "mdi-dice-6"
            } else if (image == 'fas fa-bomb') {
                mdIconName = "mdi-bomb"
            } else if (image == 'fas fa-chess') {
                mdIconName = "mdi-chess-queen"
            } else if (image == 'fas fa-rocket') {
                mdIconName = "mdi-rocket"
            } else if (image == 'fas fa-diamond') {
                mdIconName = "mdi-diamond"
            } else if (image == 'fas fa-user-robot') {
                mdIconName = "mdi-robot"
            }  else if (image == 'fas fa-raygun') {
                mdIconName = "mdi-ray-gun"
            } else if (image == 'fas fa-dice-d10') {
                mdIconName = "mdi-dice-d10"
            } else if (image == 'fas fa-dice-d6') {
                mdIconName = "mdi-dice-d6"
            } else if (image == 'fas fa-snake') {
                mdIconName = "mdi-snake"
            } else if (image == 'fas fa-meteor') {
                mdIconName = "mdi-meteor"
            } else {
                mdIconName = "mdi-poker-chip"
            }
            return mdIconName
        },
        toggleNavbar() {
            if (this.$route.path == "/") {
                this.isToggleNavbar = false;
            } else {
                this.isToggleNavbar = !this.isToggleNavbar;
            }
        },
        away() {
            this.isToggleNavbar = false;
        },
        removeCartx(item) {
            this.removeCart(item)

        },
        addCartx(item) {
            this.addCart(item);
        },
        SignInWithLine() {
            this.signInWithLine();
        },
        async SignIn() {
            let objLogin = {
                Username: this.Username,
                Password: this.Password
            }
            let resLogin = await this.signIn(objLogin);
            if (resLogin) {
                this.dialog = false;
            }
            // console.log('AppBar.vue => SignIn' , resLogin)
        },
        SetModalClose() {
            this.setModalLogin(false);
        },
        SetModalRegisClose() {
            this.setModalRegister(false);
        },
        async SendRequestOTP() {
            let  objReqRequestOTP = {
                tel: this.register_tel
            }
            let resultOTP = await this.requestOTP(objReqRequestOTP);
            // console.log('AppBar.vue => SendRequestOTP' , resultOTP)
            if (resultOTP != false) {

            }
        },
        async SendRequestOTPVerify() {
            let  objReqRequestOTPVerify = {
                tel: this.register_tel,
                otp: this.register_opt_verify
            }
            let resultOTP = await this.ConfirmOTP(objReqRequestOTPVerify);
            // console.log('AppBar.vue => SendRequestOTPVerify' , resultOTP)
            if (resultOTP != false) {

            }
        },
        async SendPassword() {
            let  objReqRequestPassword = {
                pass: this.register_pass,
                pass_confirm: this.register_pass_confirm
            }
            let resultPassword = await this.CheckPassword(objReqRequestPassword);
            // console.log('AppBar.vue => SendPassword' , resultPassword)
            if (resultPassword != false) {

            }
        },
        async SendRegister() {
            // log this.bankAccount
            // console.log('AppBar.vue => SendRegister' , this.bankAccount)
            this.isAllowBankName = false;
            let objSendDataRegister = {
                MEMBER_LINE: '',
                MEMBER_IP: '',
                MEMBER_BANK: this.bankAccount.code,
                MEMBER_ACCID: this.bankAccountNo,
                MEMBER_BANK_NAME: this.bankAccountName,
                MEMBER_TRUE_ACCID: '',
                MEMBER_CONTACT: '',
                isAllowBankName: this.isAllowBankName,
                TEL: '',
                PWD: '',
                OTP: ''
            }
            let resultRegister = await this.RegisterData(objSendDataRegister);
            debugger
            if (resultRegister != false) {
                if (resultRegister.Status == 'ERROR') {
                    if (resultRegister.Code == 1001) {
                        this.isAllowBankName = true;
                    }
                }
            }
            // console.log('AppBar.vue => SendRegister' , resultRegister)
            
            // MEMBER_LINE: 
            // MEMBER_IP: 127.0.0.1
            // typeBank: bank
            // MEMBER_BANK: KBANK
            // MEMBER_ACCID: 7783744644
            // MEMBER_BANK_NAME: 
            // MEMBER_TRUE_ACCID: 
            // MEMBER_CONTACT: Facebook
            // TEL: 0882604882
            // PWD: 123123
            // OTP: 932803
        },
        setModalGoToRegister() {
            this.setModalLogin(false);
            this.setModalRegister(true);
        },
        toggleDrawer() {
            this.drawer = !this.drawer;
        },
        goToMenu(item) {
            if (item.link == '/logout') {
                this.logout();
                this.$router.push('/');
                this.drawer = false;
            } else {
                if (!this.getIsLogin) {
                    createToastInterface().error('กรุณาเข้าสู่ระบบก่อนใช้งาน')
                    return
                }
                if(item.isCompleted) this.$router.push(item.link)
            }
        }
    },
};
</script>
<style lang="scss" scoped>
$z-index-sub-topbar: 2;
$md: 959px;
$z-99: 99;

.top-categories-img {
    width: 385px;
    min-width: 100%;
    max-width: 100%;

}

.card-cat-game {
    width: 70px;
    height: 70px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #2d2d2d;
    border-radius: 10px;
}
.z-999 {
    z-index: 999;
}

.custom-dialog {
  position: fixed;
  bottom: 0; /* Position at the bottom */
  left: 0;
  right: 0;
  height: 50vh; /* Half the viewport height */
  overflow-y: auto; /* Enable scrolling if content exceeds height */
}

.v-list-item {
    min-height: 34px;
}

.top-bar {
    height: 40px;
    display: flex;
    align-items: center;
}

.sale-page-one {
    .sub-topbar {
        &.v-app-bar--is-scrolled {
            position: relative;

            .dropdown-ecommerce {
                display: none;
            }
        }
    }

    .navbar {
        &.v-app-bar--is-scrolled {
            top: 0;
            margin-bottom: 0px;
        }
    }
}

.sale-page-two {
    .sub-topbar {
        &.v-app-bar--is-scrolled {
            position: relative;

            .dropdown-ecommerce {
                display: none;
            }
        }
    }

    .navbar {
        &.v-app-bar--is-scrolled {
            top: 0;
            margin-bottom: 0px;
        }
    }
}

.sub-topbar {
    position: relative;
    box-shadow: none !important;
    width: 100%;
    height: 80px !important;
    z-index: $z-99;

    .dropdown-ecommerce {
        display: none;
    }

    &.v-app-bar--fixed {
        position: unset;
    }

    // z-index: $z-index-sub-topbar;

    &.v-app-bar--is-scrolled {
        position: fixed;
        top: 0;
        box-shadow: none !important;

        .dropdown-ecommerce {
            display: block;
        }
    }

    @media (max-width: $md) {}
}

.navbar {
    height: 60px;
    width: 100%;
    z-index: 2;
    box-shadow: rgb(43 52 69 / 10%) 0px 16px 16px -16px !important;

    &.v-app-bar--is-scrolled {
        position: relative;
        top: 64px;
        margin-bottom: 64px;
        box-shadow: rgb(43 52 69 / 10%) 0px 16px 16px -16px !important;
        // box-shadow: none !important;
    }

    @media (max-width: 992px) {
        display: none;
    }
}

.search-bar {
    ::v-deep .v-input__slot {
        border: 1px solid rgb(218, 225, 231);
        background-color: #fff !important;

    }

    .search-bar-dropdown {

        height: 39px;
        position: absolute;
        top: 20px;
        transform: translateY(-50%);
        right: 2px;
        border-radius: 22px;
        border-top-left-radius: 0px;
        border-bottom-left-radius: 0px;
        border-left: 1px solid rgb(218, 225, 231) !important;
        box-shadow: none !important;

        @media (max-width: $md) {
            display: none;
        }
    }

    ::v-deep .v-text-field__details {
        display: none;
    }
}

// toggleNavbarButton
.navbar-toggle-dropdown {
    z-index: 98;
    display: none;

    &.open {
        display: block;
        top: 64px;
    }
}

.v-hidden {
    visibility: hidden;
}

.empty-cart-sidebar {
    height: 80vh
}
</style>